import { Drawer, styled } from '@mui/material';

import { VAR_AREA_BOT } from '@mopla/constants';
import { getShouldForwardPropFn } from '@mopla/utils';

export const DragHandleArea = styled('div')({
	padding: '12px 16px 8px',
	display: 'flex',
	justifyContent: 'center',
	touchAction: 'none',
	cursor: 'grab',
	userSelect: 'none',
	WebkitUserSelect: 'none',
	WebkitTouchCallout: 'none',
	'&:active': {
		cursor: 'grabbing',
	},
	'@media (pointer: coarse)': {
		padding: '16px 12px',
	},
});

export const DragHandle = styled('div')(({ theme }) => ({
	width: 72,
	height: 6,
	backgroundColor: theme.palette.solutions?.[100],
	borderRadius: 6,
	userSelect: 'none',
	WebkitUserSelect: 'none',
	WebkitTouchCallout: 'none',
}));

export const DrawerStyled = styled(Drawer)(() => ({
	'& .MuiPaper-root': {
		borderTop: 'none',
		borderTopLeftRadius: 16,
		borderTopRightRadius: 16,
		/* RPA/Elevation 4 */
		boxShadow: '0 3px 20px 0 rgba(0, 0, 0, 0.25)',
		display: 'flex',
		flexDirection: 'column',
		overflow: 'hidden',
		pointerEvents: 'auto',
		touchAction: 'pan-y',
	},
}));

export const DrawerHeaderSlot = styled('div')(() => ({
	paddingInline: 16,
	touchAction: 'none',

	'& + .drawerContent': {
		paddingTop: 16,
	},
}));

export const DrawerContentArea = styled('div', {
	shouldForwardProp: getShouldForwardPropFn('hideScrollbar'),
})<{ hideScrollbar?: boolean }>(({ hideScrollbar }) => ({
	flex: 1,
	display: 'flex',
	flexDirection: 'column',
	minHeight: 0,
	overflow: 'auto',
	touchAction: 'pan-y',
	paddingInline: 16,
	overscrollBehavior: 'contain',
	'.platform-ios.keyboard-is-open &': {
		paddingBottom: 'var(--keyboard-height, 0px)',
	},

	...(hideScrollbar && {
		'&::-webkit-scrollbar': {
			display: 'none',
		},
	}),
}));

export const FooterArea = styled('div', {
	shouldForwardProp: getShouldForwardPropFn('elevated'),
})<{ elevated?: boolean }>(({ theme, elevated }) => ({
	'&:empty': {
		display: 'none',
	},
	'body.keyboard-is-open &': {
		display: 'none',
	},
	padding: `16px 16px max(32px, ${VAR_AREA_BOT})`,
	...(elevated && {
		borderRadius: '16px 16px 0 0',
		boxShadow: '0 3px 21.4px 0 rgba(0, 0, 0, 0.25)',
		backgroundColor: theme.palette.common.white,
	}),
}));
